<div class="h-full" style="padding: 24px 26px; background-color: var(--brand-surface)">
  <p class="modal-v2-eyebrow">Venda Cartão</p>
  <p class="vc-titulo">Ofertar plano sem senha</p>
  <p class="vc-sub">Conta no relatório como venda fora do atendimento, no seu nome.</p>

  <ng-container *ngIf="tela !== 'oferta'">
    <label for="vcCpf" class="rotulo-v2" style="margin-top: 16px">CPF do cliente</label>
    <form class="flex gap-2" (ngSubmit)="buscar()">
      <input id="vcCpf" name="vcCpf" class="campo-v2 flex-1" style="height: 42px" [(ngModel)]="cpfDigitado"
             inputmode="numeric" maxlength="14" autocomplete="off" placeholder="Digite o CPF" [disabled]="buscando" />
      <button type="submit" class="vc-btn prim" [disabled]="buscando">{{ buscando ? 'Buscando...' : 'Buscar' }}</button>
    </form>

    <p *ngIf="erro" class="aviso-v2 vermelho mt-3">{{ erro }}</p>
  </ng-container>

  <div *ngIf="tela === 'resultado'" class="vc-cartao" style="margin-top: 14px">
    <ng-container *ngIf="paciente; else naoEncontrado">
      <div class="flex items-center gap-2.5">
        <span class="vc-avatar">{{ iniciais }}</span>
        <div class="flex-1 min-w-0">
          <p class="truncate" style="font-size: 14px; font-weight: 700; color: var(--tx)">{{ paciente.nmPessoaFisica }}</p>
          <p style="font-size: 12px; color: var(--tx-2)">CPF {{ cpfMascarado }} · código {{ paciente.cdPessoaFisica }}</p>
        </div>
        <span *ngIf="acao === 'adesao'" class="vc-chip">Não é cliente</span>
        <span *ngIf="acao === 'upsell'" class="vc-chip verde">Cliente</span>
        <span *ngIf="acao === 'atraso'" class="vc-chip ambar">Em atraso</span>
      </div>

      <p *ngIf="textoOfertaAnterior && (acao === 'adesao' || acao === 'upsell')" class="aviso-v2 ambar mt-3">
        ↺ {{ textoOfertaAnterior }}
      </p>
      <p *ngIf="regularizou" class="aviso-v2 verde mt-3">
        Regularizado. {{ acao === 'upsell' ? 'Agora dá para oferecer o melhorar plano.' : 'A assinatura ainda está sendo atualizada no CartãoSiM.' }}
      </p>
      <p *ngIf="acao === 'atraso' && temPendenciaAtraso === false" class="aviso-v2 ambar mt-3">
        Cliente com pagamento em atraso, procure a regularização no atendimento.
      </p>
      <p *ngIf="acao === 'adesao' && adesaoBloqueada" class="aviso-v2 ambar mt-3">
        A adesão fica liberada depois que as faturas abaixo forem resolvidas.
      </p>
      <p *ngIf="acao === 'indisponivel'" class="mt-3" style="font-size: 12px; color: var(--tx-2)">
        Oferta indisponível para este cliente.
      </p>

      <div class="flex flex-wrap justify-end gap-2 mt-3">
        <button *ngIf="acao === 'adesao'" type="button" class="vc-btn prim" [disabled]="!adesaoLiberada" (click)="ofertar()">
          {{ verificandoAdesao ? 'Verificando CartãoSiM…' : 'Ofertar adesão →' }}
        </button>
        <button *ngIf="acao === 'upsell'" type="button" class="vc-btn prim" (click)="ofertar()">Melhorar plano →</button>
      </div>
    </ng-container>

    <ng-template #naoEncontrado>
      <p style="font-size: 14px; font-weight: 700; color: var(--tx)">Nenhum paciente com este CPF</p>
      <p style="font-size: 12px; color: var(--tx-2); margin-top: 2px">CPF {{ cpfMascarado }} · cadastre para ofertar o plano.</p>
      <div class="flex flex-wrap justify-end gap-2 mt-3">
        <button type="button" class="vc-btn prim" (click)="showCadastro = true">Cadastrar paciente</button>
      </div>
    </ng-template>
  </div>

  <!-- Mesmos cards do abrir-atendimento: regularização (com régua e Enel por ticket), canceladas e bloqueio de adesão -->
  <div *ngIf="tela === 'resultado' && paciente" class="flex flex-col gap-3" style="margin-top: 14px">
    <app-pendencia-sim *ngIf="acao === 'atraso'" [naPausa]="true"
                       [personId]="paciente.cdPessoaFisica" [clinicId]="clinicId" [cpf]="cpf" [guiche]="guiche"
                       (temPendencia)="temPendenciaAtraso = $event" (regularizado)="onRegularizado()"></app-pendencia-sim>
    <ng-container *ngIf="acao === 'adesao'">
      <app-pendencia-cancelada-sim [naPausa]="true" [personId]="paciente.cdPessoaFisica" [clinicId]="clinicId" [cpf]="cpf" [guiche]="guiche"
                                   (temPendencia)="onTemCancelada($event)"></app-pendencia-cancelada-sim>
      <app-bloqueio-adesao-sim *ngIf="!temCancelada" [naPausa]="true" [personId]="paciente.cdPessoaFisica"
                               (temBloqueio)="temBloqueio = $event"></app-bloqueio-adesao-sim>
    </ng-container>
  </div>

  <ng-container *ngIf="tela === 'oferta' && paciente">
    <div class="vc-cartao flex items-center gap-2.5" style="margin-top: 16px; padding: 10px 14px">
      <div class="flex-1 min-w-0">
        <p class="truncate" style="font-size: 13px; font-weight: 700; color: var(--tx)">{{ paciente.nmPessoaFisica }}</p>
        <p style="font-size: 12px; color: var(--tx-2)">CPF {{ cpfMascarado }}</p>
      </div>
      <button type="button" class="vc-btn sec" style="height: 34px; padding: 0 12px" (click)="trocarCpf()">Trocar CPF</button>
    </div>

    <div *ngIf="vendido" class="aviso-v2 verde flex items-center gap-3 mt-3">
      <span class="flex-1">{{ sucesso }}</span>
      <button type="button" class="vc-btn prim" style="height: 34px; padding: 0 14px" (click)="trocarCpf()">Próximo CPF</button>
    </div>

    <div class="mt-3">
      <app-oferta-sim *ngIf="acao === 'adesao'"
                      [clinicId]="clinicId" [personId]="paciente.cdPessoaFisica" [cpf]="cpf" [guiche]="guiche"
                      [convenioParticular]="true" [procedimentos]="[]" [senhaId]="0" [origem]="'venda_cartao'"
                      (ativada)="onVendido()"></app-oferta-sim>
      <app-melhorar-plano-sim *ngIf="acao === 'upsell'"
                              [clinicId]="clinicId" [personId]="paciente.cdPessoaFisica" [cpf]="cpf" [guiche]="guiche"
                              [abrirDireto]="true" [origem]="'venda_cartao'"
                              (migrado)="onVendido()"></app-melhorar-plano-sim>
    </div>
  </ng-container>
</div>

<app-cadastro-paciente-modal [aberto]="showCadastro" [cpfInicial]="cpf" [clinicId]="clinicId"
                             (fechar)="showCadastro = false" (cadastrado)="onCadastrado($event)"></app-cadastro-paciente-modal>
